import { addDays, addMinutes } from "date-fns";
import { useState, useEffect } from "react";
import { useGetByIdAndTimeSummarizedQuery } from "../../../services/historicalData";
import { themedUseStyletron } from "../../../theme/customTheme";
import { ValueDisplayWithLabel, ValueDisplay } from "../../components/ValueDisplay";
import { BsArrowDownRight, BsArrowUpRight, BsArrowRight } from 'react-icons/bs'
import { PropertiesPlugin } from "@microsoft/applicationinsights-web";
import { CounterType } from "../CounterType";
import { Block } from "baseui/block";

export function SingleItemCompare({ propertyName, objectId, dimension, label, type, resourceGroupId, days }: any) {
    const [, theme] = themedUseStyletron();
    const color = theme.colors.primary;

    const displayDimension = dimension === 'MWh' ? 'kWh' : dimension === 'Wh' ? 'kWh' : dimension === 'l' ? 'm³' :dimension

    const current = new Date();
    const timezoneOffset = (new Date()).getTimezoneOffset() * -1;
    const [state, setState] = useState({
        start: addDays(addMinutes(new Date(current.getFullYear(), current.getMonth(), current.getDate()), timezoneOffset), -days),
        end: addMinutes(current, timezoneOffset)
    })
    const [stateLast, setStateLast] = useState({
        start: addDays(addMinutes(new Date(current.getFullYear(), current.getMonth(), current.getDate()), timezoneOffset), -(2*days)),
        end: addDays(addMinutes(current, timezoneOffset), -days)
    })
    const [sumValue, setSumValue] = useState(0);
    const [sumValueLast, setSumValueLast] = useState(0);
    const [pValue, setPValue] = useState(0);
    const colorP = type != CounterType.FeedOut ? (pValue <= 95 ? theme.appColors.aggregate.on : pValue >= 105 ? theme.appColors.aggregate.error : theme.appColors.aggregate.off) : (pValue <= 95 ? theme.appColors.aggregate.error : pValue >= 105 ? theme.appColors.aggregate.on : theme.appColors.aggregate.off);
    const icon = pValue <= 95 ? BsArrowDownRight : pValue >= 105 ? BsArrowUpRight : BsArrowRight;
    const { data, isSuccess } = useGetByIdAndTimeSummarizedQuery(
        {
            id: objectId,
            resourceGroupId: resourceGroupId,
            propertyName: propertyName,
            start: state.start.toUTCString(),
            end: state.end.toUTCString(),
            summarizeBy: 'year'
        });

    const { data: dataLast, isSuccess: isSuccessLast } = useGetByIdAndTimeSummarizedQuery(
        {
            id: objectId,
            resourceGroupId: resourceGroupId,
            propertyName: propertyName,
            start: stateLast.start.toUTCString(),
            end: stateLast.end.toUTCString(),
            summarizeBy: 'year'
        });


    useEffect(() => {
        var sum: number;
        sum = 0;
        data?.forEach((el) => {
            sum = sum + el.sumValue;
        })
        setSumValue(sum);
    }, [data]);

    useEffect(() => {
        var sum: number;
        sum = 0;
        dataLast?.forEach((el) => {
            sum = sum + el.sumValue;
        })
        setSumValueLast(sum);
    }, [dataLast]);

    useEffect(() => {
        if (type === CounterType.Producer)
            setPValue((sumValueLast / sumValue * 100));
        else
            setPValue((sumValue / sumValueLast * 100));
    }, [sumValue, sumValueLast]);

    return (
        <Block display={'flex'} alignItems='baseline' flexDirection='row' gridGap={'20px'}>
            {(isSuccess && data && data.length > 0) &&
                (
                    (label ?
                        (<ValueDisplayWithLabel color={color} label={label} value={sumValue} dimension={displayDimension}></ValueDisplayWithLabel>)
                        :
                        (<ValueDisplay color={color} value={sumValue} dimension={displayDimension}></ValueDisplay>)
                    )


                )
            }
            {(sumValue > 0 && sumValueLast > 0) &&
                <Block display={'flex'} flexDirection='row' alignItems='center' gridGap={theme.sizing.scale100}>
                    {(sumValue && sumValueLast) && type === CounterType.Producer &&
                        <ValueDisplay small color={colorP} value={(pValue - 100) * -1} dimension={'%'}></ValueDisplay>
                    }
                    {(sumValue && sumValueLast) && type !== CounterType.Producer &&
                        <ValueDisplay small color={colorP} value={pValue - 100} dimension={'%'}></ValueDisplay>
                    }
                    {(pValue <= 95) && type === CounterType.Producer &&
                        <BsArrowUpRight color={colorP} size={theme.sizing.scale800}></BsArrowUpRight>
                    }
                    {(pValue <= 95) && type !== CounterType.Producer &&
                        <BsArrowDownRight color={colorP} size={theme.sizing.scale800}></BsArrowDownRight>
                    }
                    {(pValue >= 105) && type === CounterType.Producer &&
                        <BsArrowDownRight color={colorP} size={theme.sizing.scale800}></BsArrowDownRight>
                    }
                    {(pValue >= 105) && type !== CounterType.Producer &&
                        <BsArrowUpRight color={colorP} size={theme.sizing.scale800}></BsArrowUpRight>
                    }
                    {(pValue < 105 && pValue > 95) &&
                        <BsArrowRight color={colorP} size={theme.sizing.scale800}></BsArrowRight>
                    }
                </Block>
            }
            {(sumValue < 0 && sumValueLast < 0) &&
                <Block display={'flex'} flexDirection='row' alignItems='center' gridGap={theme.sizing.scale100}>
                    {(sumValue && sumValueLast) && type !== CounterType.Producer &&
                        <ValueDisplay small color={colorP} value={pValue - 100} dimension={'%'}></ValueDisplay>
                    }
                    {(pValue <= 95) && type !== CounterType.Producer &&
                        <BsArrowDownRight color={colorP} size={theme.sizing.scale800}></BsArrowDownRight>
                    }
                    {(pValue >= 105) && type !== CounterType.Producer &&
                        <BsArrowUpRight color={colorP} size={theme.sizing.scale800}></BsArrowUpRight>
                    }
                    {(pValue < 105 && pValue > 95) &&
                        <BsArrowRight color={colorP} size={theme.sizing.scale800}></BsArrowRight>
                    }
                </Block>
            }
        </Block>

    )
}
